export default "__VITE_ASSET__52e657db__"